import * as Lo from 'lodash';
import React, { lazy, useCallback } from 'react';
import { generatePath, useLocation, useHistory } from 'react-router-dom';

import { HomePage } from 'pages';

import {
  CollectionpointsGridPage,
  CollectionpointsMapPage,
  CollectionpointsStatsPage,
  CollectionsGridPage,
  CollectorFormPage,
  CollectorsGridPage,
  ContactsGridPage,
  ContactFormPage,
  ContainerOrdersGridPage,
  ContainertypesGridPage,
  CpGroupPage,
  CpGroupsPage,
  CpSubGroupPage,
  CpSubSubGroupPage,
  DriversGridPage,
  DriversAppEntriesGridPage,
  // DriverEntryFormPage,
  InternalTransactionsGridPage,
  MaterialsGridPage,
  RouteFormPage,
  RoutesGridPage,
  SeriesFormPage,
  SeriesGridPage,
  UserFormPage,
  UsersGridPage,
  VehiclesGridPage,
  WastereceptionpointsGridPage,
  WastereceptionpointTransactionsGridPage,
  AuditTrailsPage,
  AuditTrailFormPage,
  ApplogGridPage,
  ApplogFormPage,
  EMailsRepoGridPage,
  UsersStatsPage,
  CollectionsPivotPage,
  CollectionsSrvPivotPage,
  TaxofficeGridPage,
} from 'shared-pages';
import { DriverFormPage } from 'shared-pages/pages/drivers/form/driver-form-page';
import { VehicleFormPage } from 'shared-pages/pages/vehicles/form/vehicle-form-page';
import { RegionsGridPage } from 'shared-pages/pages/regions';
import { NomoiGridPage } from 'shared-pages/pages/nomoi';
import { IdocFormPage, IdocsGridPage } from 'shared-pages/pages/idocs';
import { WRecPointFormPage } from 'shared-pages/pages/waste-reception-points/form/wrecpoint-form-page';
import { CollectionPointFormPage } from 'shared-pages/pages/collection-points/form/collectionpoint-form-page';
import { CollectionOrdersGridPage } from 'shared-pages/pages/collection-orders';
import OrderFormPage from 'shared-pages/pages/collection-orders/form/order-form-page';
import { CollectionFormPage } from 'shared-pages/pages/collections/form/collection-form-page';
import { InternalTransactionFormPage } from 'shared-pages/pages/internal-transactions-page/form/internal-transaction-form-page';
import ContainerOrderFormPage from 'shared-pages/pages/container-orders/form/containerOrder-form-page';
import { CollectionpointReqGridPage } from 'shared-pages/pages/collection-point-requests/grid/collectionpointreq-grid-page';
import { CollectionPointRequestFormPage } from 'shared-pages/pages/collection-point-requests/form/collectionpointRequest-form-page';
import { ProductionGridPage } from 'shared-pages/pages/production/grid/production-grid-page';
import { ProductionFormPage } from 'shared-pages/pages/production/form/production-form-page';
import CollectionPointReport from 'shared-pages/pages/collection-point-report/grid/collection-point-report-grid-page';
import { SubregionsGridPage } from 'shared-pages/pages/subregions';
import { JobtypesGridPage } from 'shared-pages/pages/jobtypes/grid/jobtypes-grid-page';
import { Postalcode2GridPage } from 'shared-pages/pages/postalcodes2/grid/postalcode-grid-page';
import { Postalcode2FormPage } from 'shared-pages/pages/postalcodes2/form/postalcode2-form-page';
import MaterialReport from 'shared-pages/pages/material-report/source/MaterialReport';
import { CollectionsRepDgrmPage } from 'shared-pages/pages/reports/collections-rep-dgrm/collections-rep-dgrm-page';

import { JobtypesFormPage } from 'shared-pages/pages/jobtypes/form/jobtypes-form-page';
import { UserRoles } from 'shared-pages/common/constants';
import { EdocsGridPage } from 'shared-pages/pages/edocs';
import { commonRoutes } from 'shared-pages/common/routes';

class RouteType {
  name: string;
  path: string;
  component: React.ComponentType<any>;
  state?: object;
  userRoles?: UserRoles[] = [UserRoles.All]; // Roles με πρόσβαση
}

export const routes: RouteType[] = [
  ...commonRoutes, // <================ COMMON ROUTES
  { name: 'HomePage', path: '/', component: HomePage },
  { name: 'Postalcodes2', path: '/postalcodes2', component: Postalcode2GridPage },
  { name: 'Postalcodes2Form', path: '/postalcodes2/:id', component: Postalcode2FormPage },
  { name: 'Taxoffices', path: '/taxoffices', component: TaxofficeGridPage },
  { name: 'Contacts', path: '/contacts', component: ContactsGridPage },
  { name: 'Productions', path: '/production', component: ProductionGridPage },
  { name: 'Production', path: '/production/:id', component: ProductionFormPage },
  { name: 'DriversEntries', path: '/drv-entries', component: DriversAppEntriesGridPage },
  {
    name: 'CollectionPointReport',
    path: '/collectionpointreport',
    component: CollectionPointReport,
  },
  {
    name: 'MaterialReport',
    path: '/materialreport',
    component: MaterialReport,
  },
  {
    name: 'CollectionsRepDgrm',
    path: '/reports/collections-diagram',
    component: CollectionsRepDgrmPage,
  },
  {
    name: 'CollectionsSrvPivot',
    path: '/coll-srvpivot',
    component: CollectionsSrvPivotPage,
  },

  {
    name: 'Edocs',
    path: '/edocs',
    component: EdocsGridPage,
  },

  // { name: 'CollectionsPivot', path: '/collections-pivot', component: CollectionsPivotPage },

  /*
  { name: 'Users', path: '/users', component: UsersGridPage },
  { name: 'User', path: '/user/:id', component: UserFormPage },
  { name: 'Materials', path: '/materials', component: MaterialsGridPage },
  { name: 'ContainerTypes', path: '/containers', component: ContainertypesGridPage },
  { name: 'CpGroups', path: '/cpgroups', component: CpGroupsPage },
  { name: 'CpGroup', path: '/cpgroup/:id', component: CpGroupPage },
  { name: 'CpSubGroup', path: '/cpsubgroup/:selected/:id', component: CpSubGroupPage },
  {
    name: 'CpSubSubGroup',
    path: '/cpsubsubgroup/:selected/:selectedSub/:id',
    component: CpSubSubGroupPage,
  },
  { name: 'Collectors', path: '/collectors', component: CollectorsGridPage },
  { name: 'Collector', path: '/collector/:id', component: CollectorFormPage },
  { name: 'Vehicles', path: '/vehicles', component: VehiclesGridPage },
  { name: 'Vehicle', path: '/vehicle/:id', component: VehicleFormPage },
  { name: 'Drivers', path: '/drivers', component: DriversGridPage },
  { name: 'Driver', path: '/driver/:id', component: DriverFormPage },
  // { name: 'DriverEntry', path: '/drv-entry/:id', component: DriverEntryFormPage },
  { name: 'Series', path: '/series', component: SeriesGridPage },
  { name: 'SeriesForm', path: '/serie/:id', component: SeriesFormPage },
  { name: 'WasteReceptionPoints', path: '/wrecpoints', component: WastereceptionpointsGridPage },
  {
    name: 'WasteReceptionPointsDa',
    path: '/wrecpointsda',
    component: WastereceptionpointsGridPage,
  },
  { name: 'WasteReceptionPoint', path: '/wrecpoint/:id', component: WRecPointFormPage },
  { name: 'WasteReceptionPointDa', path: '/wrecpointda/:id', component: WRecPointFormPage },
  { name: 'Collectionpoints', path: '/collpoints', component: CollectionpointsGridPage },
  { name: 'Collectionpoint', path: '/collpoint/:id', component: CollectionPointFormPage },
  { name: 'CollectionpointContact', path: '/contact/:id', component: ContactFormPage },
  {
    name: 'CollectionpointRequests',
    path: '/collectionpointrequests',
    component: CollectionpointReqGridPage,
  },
  {
    name: 'CollectionpointRequest',
    path: '/collectionpointrequest/:id',
    component: CollectionPointRequestFormPage,
  },
  { name: 'Regions', path: '/regions', component: RegionsGridPage },
  { name: 'Subregions', path: '/subregions', component: SubregionsGridPage },
  { name: 'Nomoi', path: '/nomoi', component: NomoiGridPage },
  { name: 'Jobtypes', path: '/jobtypes', component: JobtypesGridPage },
  { name: 'JobtypesForm', path: '/jobtype/:id', component: JobtypesFormPage },
  { name: 'Idocs', path: '/idocs', component: IdocsGridPage },
  { name: 'Idoc', path: '/idoc/:id', component: IdocFormPage },
  { name: 'Orders', path: '/orders', component: CollectionOrdersGridPage },
  { name: 'Order', path: '/order/:id', component: OrderFormPage },
  { name: 'Routes', path: '/routes', component: RoutesGridPage },
  { name: 'Route', path: '/route/:id', component: RouteFormPage },
  { name: 'Collections', path: '/collections', component: CollectionsGridPage },
  { name: 'Collection', path: '/collection/:id', component: CollectionFormPage },
  { name: 'ITrans', path: '/itrans', component: InternalTransactionsGridPage },
  { name: 'ITran', path: '/itran/:id', component: InternalTransactionFormPage },
  { name: 'WrsTrans', path: '/wrstrans', component: WastereceptionpointTransactionsGridPage },
  { name: 'CPMap', path: '/cpmap', component: CollectionpointsMapPage },
  { name: 'CPStats', path: '/cpstats', component: CollectionpointsStatsPage },
  { name: 'ContainerOrders', path: '/containerorders', component: ContainerOrdersGridPage },
  { name: 'ContainerOrder', path: '/containerorder/:id', component: ContainerOrderFormPage },
  {
    name: 'CollectionPointReport',
    path: '/collectionpointreport',
    component: CollectionPointReport,
  },
  {
    name: 'MaterialReport',
    path: '/materialreport',
    component: MaterialReport,
  },
  {
    name: 'CollectionsRepDgrm',
    path: '/reports/collections-diagram',
    component: CollectionsRepDgrmPage,
  },
  {
    name: 'CollectionsSrvPivot',
    path: '/coll-srvpivot',
    component: CollectionsSrvPivotPage,
  },
  {
    name: 'Edocs',
    path: '/edocs',
    component: EdocsGridPage,
  },

  { name: 'CollectionsPivot', path: '/collections-pivot', component: CollectionsPivotPage },
  */
];

//Connects the name that's given as an argument with the route's path!
export function getRouteByName(name: string): string {
  const idx = Lo.findIndex(routes, ['name', name]);
  if (idx === -1) return '/';
  return routes[idx].path;
}

export class Paths {
  static user = (id) => {
    return generatePath(getRouteByName('User'), { id: id });
  };
  static users = () => {
    return generatePath(getRouteByName('Users'));
  };
}

export function useNavigateTo() {
  const location = useLocation<any>();
  const history = useHistory();

  const navigateTo = useCallback<(path: string) => void>(
    (path) => {
      history.push({
        pathname: path,
        state: {
          pathname: location.pathname,
          ...location.state,
        },
      });
    },
    [history, location.pathname, location.state],
  );
  return navigateTo;
}
